import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="border-t border-border bg-card">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-muted-foreground">
        <span className="text-center sm:text-left leading-relaxed">
          Copyright {currentYear} Creeks Edge Consulting Group, LLC. All rights reserved.
        </span>
        <nav className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2">
          <Link
            to="/privacy-policy"
            className="min-h-[44px] min-w-[44px] flex items-center hover:text-foreground transition-colors px-1"
          >
            Privacy Policy
          </Link>
          <span className="text-border hidden sm:inline" aria-hidden="true">|</span>
          <Link
            to="/legal-terms"
            className="min-h-[44px] min-w-[44px] flex items-center hover:text-foreground transition-colors px-1"
          >
            Legal
          </Link>
          <span className="text-border hidden sm:inline" aria-hidden="true">|</span>
          <Link
            to="/cookie-policy"
            className="min-h-[44px] min-w-[44px] flex items-center hover:text-foreground transition-colors px-1"
          >
            Cookie Policy
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
